import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import brandLogo from "assets/images/logos/logo-publique.png";

export default function SessionLoading({ error, onRetry, onSignOut }) {
  return (
    <Box
      sx={{ minHeight: "100dvh", bgcolor: "#f4f8f5", display: "grid", placeItems: "center", p: 3 }}
    >
      <Stack
        alignItems="center"
        spacing={2.5}
        sx={{ width: "100%", maxWidth: 420, textAlign: "center" }}
      >
        <Box
          component="img"
          src={brandLogo}
          alt="Publique Sua Obra"
          sx={{ width: 100, height: 130, objectFit: "contain" }}
        />
        {error ? (
          <>
            <Alert severity="error" sx={{ width: "100%", textAlign: "left" }}>
              {error}
            </Alert>
            <Stack direction="row" spacing={2}>
              <Button onClick={onRetry} variant="contained" color="success">
                Tentar novamente
              </Button>
              <Button onClick={onSignOut}>Sair da conta</Button>
            </Stack>
          </>
        ) : (
          <Box role="status" aria-live="polite" aria-busy="true">
            <CircularProgress size={32} sx={{ color: "#147d48", mb: 2 }} />
            <Typography sx={{ color: "#182d27", fontSize: 20, fontWeight: 700 }}>
              Verificando seu acesso
            </Typography>
            <Typography sx={{ color: "#64766e", fontSize: 14, mt: 1, lineHeight: 1.6 }}>
              Estamos conferindo sua sessão, suas permissões e o aceite dos termos de uso.
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}
